// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as OrderCancellationReasonsApiModel from "../api-model/OrderCancellationReasonsApiModel.bs.js";

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(OrderCancellationReasonsApiModel.t_decode(json), "OrderCancellationReasonsEntityMapper.res");
  return {
          customer_reasons: List.map((function (reason) {
                  return {
                          id: reason.id,
                          name: reason.name
                        };
                }), res.reasons_for_customers),
          partner_reasons: List.map((function (reason) {
                  return {
                          id: reason.id,
                          name: reason.name
                        };
                }), res.reasons_for_drivers),
          allocation_reasons: List.map((function (reason) {
                  return {
                          id: reason.id,
                          name: reason.name
                        };
                }), res.reasons_for_allocation)
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
